import React from "react";
import "./Dashboard.css";
import { useEffect, useState } from "react";
import AddClientOverlay from "../components/adclient/AddClientOverlay";

const Dashboard = () => {
  const [statsData, setStatsData] = useState(null);
  const [recentActivitiesData, setRecentActivitiesData] = useState(null);
  const [addClient, setAddClient] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [parsedAgentData, setParsedAgentData] = useState(null);

  useEffect(() => {
    let storedAgent = localStorage.getItem("agentData");
    if (!storedAgent) {
      // Redirect to login or handle unauthenticated state
      window.location.href = "/sign-in";
      return;
    }
    let parsedAgent = JSON.parse(storedAgent);
    console.log("Parsed Agent Data:", parsedAgent);

    // check if agent is resigned or fired

    if (parsedAgent.resigned || parsedAgent.isfired) {
      alert("Your account is no longer active. Please contact support for more information.");
      localStorage.removeItem("agentData");
      window.location.href = "/sign-in";
      return;
    }

    setParsedAgentData(parsedAgent);

    const generatedStats = generateStatsData(parsedAgent);
    setStatsData(generatedStats);
    const recentActivities = formatRecentActivities(parsedAgent.recentActivities || []);

    setRecentActivitiesData(recentActivities);
  }, []);

  const quickActions = [
    /* { label: "Register Visit", icon: "📍", color: "#667eea" }, */
    { label: "Add Client", icon: "➕", color: "#10b981" },
    /*  { label: "View Payouts", icon: "💰", color: "#f59e0b" }, */
    { label: "Share Link", icon: "🔗", color: "#8b5cf6" },
  ];

  const handleCreateNewClient = async (newClient) => {
    console.log("New Client Data:", newClient);
    setIsLoading(true);
    const storedAgent = localStorage.getItem("agentData");

    if (!storedAgent) {
      console.error("No agent data found in login again");
      setIsLoading(false);
      return;
    }
    const agentID = JSON.parse(storedAgent)._id;
    console.log("Agent ID:", agentID);

    const createClientUrl = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/createClient";

    try {
      let payload = {
        clientName: newClient.clientName,
        isClientInterestedInHardware: newClient.interestedInHardware,
        clientPhoneNumber: newClient.phoneNumber,
        isClientInterestedInSoftware: newClient.interestedInSoftware,
        didClientRequestADemo: newClient.requestedDemo,
        shopAddress: newClient.shopAddress,
        shopLocation: newClient.town,
        businessCategory: newClient.businessCategory,
      };

      let response = await fetch(createClientUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newClient: payload, agentID }),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to create new client");
      }
      console.log("Create Client Response Data:", data);

      const generatedStats = generateStatsData(data.marketingAgent);
      setStatsData(generatedStats);
      localStorage.setItem("agentData", JSON.stringify(data.marketingAgent));
      alert("Client created successfully!");
    } catch (error) {
      console.log("Error creating new client:", error);
      alert("Failed to create client. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className='sl-agent-dashboard-container'>
        {/* Header */}
        <div className='sl-agent-dashboard-header'>
          <div>
            <h1>Welcome back, {parsedAgentData?.agentName?.split(" ")[0] || "Agent"}! 👋</h1>
            <p>Here's what's happening with your clients today</p>
          </div>
          {/*  <div
            onClick={async () => {
              const link = agentData?.referralLink;
              if (!link) return;

              if (navigator.share) {
                try {
                  await navigator.share({
                    title: "Join via my referral link",
                    text: "Sign up using my referral link:",
                    url: link,
                  });
                } catch (err) {
                  console.log("Share cancelled", err);
                }
              } else {
                // fallback to clipboard
                await navigator.clipboard.writeText(link);
                alert("Referral link copied to clipboard!");
              }
            }}
            className='sl-agent-referral-badge'
          >
            <span className='sl-agent-badge-icon'>🔗</span>
            <div>
              <span className='sl-agent-badge-label'>Share Referral Link</span>
              <span className='sl-agent-badge-code'>{agentData?.referralLink.slice(0, 10) + "..." || "SL-XXX"}</span>
            </div>
          </div> */}
        </div>

        {/* Stats Grid */}
        <div className='sl-agent-stats-grid'>
          {statsData?.map((stat, index) => (
            <div key={index} className='sl-agent-stat-card'>
              <div className='sl-agent-stat-icon' style={{ background: `${stat.color}15` }}>
                <span style={{ filter: `hue-rotate(${index * 30}deg)` }}>{stat.icon}</span>
              </div>
              <div className='sl-agent-stat-content'>
                <p className='sl-agent-stat-label'>{stat.label}</p>
                <div className='sl-agent-stat-value-row'>
                  <h3 className='sl-agent-stat-value'>{stat.value}</h3>
                  <span className={`sl-agent-stat-trend ${stat.trendUp ? "sl-agent-trend-up" : "sl-agent-trend-down"}`}>
                    {stat.trendUp ? "↑" : "↓"} {stat.trend}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content Grid */}
        <div className='sl-agent-dashboard-grid'>
          {/* Recent Activity */}
          <div className='sl-agent-dashboard-card'>
            <div className='sl-agent-card-header'>
              <h2>Recent Activity</h2>
              <span className='sl-agent-card-badge'>{recentActivitiesData?.length} activities</span>
            </div>
            <div className='sl-agent-activity-list'>
              {recentActivitiesData
                ?.slice()
                .reverse()
                .map((activity) => (
                  <div key={activity.id} className='sl-agent-activity-item'>
                    <div className='sl-agent-activity-icon'>{activity.icon}</div>
                    <div className='sl-agent-activity-content'>
                      <h4>{activity.client}</h4>
                      <p>{activity.action}</p>
                    </div>
                    <span className='sl-agent-activity-time'>{activity.time}</span>
                  </div>
                ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div className='sl-agent-dashboard-card'>
            <div className='sl-agent-card-header'>
              <h2>Quick Actions</h2>
            </div>
            <div className='sl-agent-quick-actions-grid'>
              {quickActions.map((action, index) => (
                <button
                  onClick={async () => {
                    if (action.label === "Add Client") {
                      setAddClient(true);
                      return;
                    }
                    const link = parsedAgentData?.referralLink;
                    if (!link) return;

                    if (navigator.share) {
                      try {
                        await navigator.share({
                          title: "Join via my referral link",
                          text: "Sign up using my referral link:",
                          url: link,
                        });
                      } catch (err) {
                        console.log("Share cancelled", err);
                      }
                    } else {
                      // fallback to clipboard
                      await navigator.clipboard.writeText(link);
                      alert("Referral link copied to clipboard!");
                    }
                  }}
                  key={index}
                  className='sl-agent-quick-action-btn'
                  style={{
                    background: `linear-gradient(135deg, ${action.color}15 0%, ${action.color}05 100%)`,
                    borderColor: `${action.color}30`,
                  }}
                >
                  <span className='sl-agent-action-icon'>{action.icon}</span>
                  <span className='sl-agent-action-label'>{action.label}</span>
                </button>
              ))}
            </div>

            {/* Performance Overview */}
            <div className='sl-agent-performance-box'>
              <h3>This Month's Performance</h3>
              <div className='sl-agent-performance-stats'>
                <div className='sl-agent-perf-item'>
                  <span className='sl-agent-perf-label'>New Clients</span>
                  <span className='sl-agent-perf-value'>
                    {parsedAgentData?.clients.filter((c) => {
                      return (
                        c.status === "new" &&
                        new Date(c.contactDate).getMonth() === new Date().getMonth() &&
                        new Date(c.contactDate).getFullYear() === new Date().getFullYear()
                      );
                    }).length || 0}
                  </span>
                </div>
                <div className='sl-agent-perf-item'>
                  <span className='sl-agent-perf-label'>Conversions</span>
                  <span className='sl-agent-perf-value'>
                    {parsedAgentData?.clients.filter((c) => {
                      return (
                        c.status === "converted" &&
                        new Date(c.contactDate).getMonth() === new Date().getMonth() &&
                        new Date(c.contactDate).getFullYear() === new Date().getFullYear()
                      );
                    }).length || 0}
                  </span>
                </div>
                <div className='sl-agent-perf-item'>
                  <span className='sl-agent-perf-label'>Leads</span>
                  <span className='sl-agent-perf-value'>
                    {parsedAgentData?.clients.filter((c) => {
                      return (
                        c.status === "lead" &&
                        new Date(c.contactDate).getMonth() === new Date().getMonth() &&
                        new Date(c.contactDate).getFullYear() === new Date().getFullYear()
                      );
                    }).length || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {addClient && <AddClientOverlay isOpen={addClient} onClose={() => setAddClient(false)} onSubmit={handleCreateNewClient} />}
    </>
  );
};

export default Dashboard;

const generateStatsData = (agentData) => {
  const stats = [
    {
      label: "Total Clients",
      value: agentData?.clients.length || 0,
      icon: "👥",
      color: "#667eea",
      trend: calculateTrend(agentData?.clients.length || 0, 2).trend,
      trendUp: calculateTrend(agentData?.clients.length || 0, 2).trendUp,
    },
    {
      label: "New Clients",
      value: agentData?.clients.filter((c) => c.status === "new").length || 0,
      icon: "✓",
      color: "#10b981",
      trend: calculateTrend(agentData?.clients.filter((c) => c.status === "new").length || 0, 1).trend,
      trendUp: calculateTrend(agentData?.clients.filter((c) => c.status === "new").length || 0, 1).trendUp,
    },
    {
      label: "Conversions",
      value: agentData.clients.filter((c) => c.status === "converted").length || 0,
      icon: "🎯",
      color: "#f59e0b",
      trend: calculateTrend(agentData.clients.filter((c) => c.status === "converted").length || 0, 1).trend,
      trendUp: calculateTrend(agentData.clients.filter((c) => c.status === "converted").length || 0, 1).trendUp,
    },
    {
      label: "Total Commission",
      value: `₦${(agentData?.totalPurchaseCommissions + agentData?.totalLeaseCommissions + agentData?.totalSubscriptionCommissions || 0).toLocaleString()}`,
      icon: "💰",
      color: "#8b5cf6",
      trend: calculateTrend(agentData?.totalPurchaseCommissions + agentData?.totalLeaseCommissions + agentData?.totalSubscriptionCommissions || 0, 0).trend,
      trendUp: calculateTrend(agentData?.totalPurchaseCommissions + agentData?.totalLeaseCommissions + agentData?.totalSubscriptionCommissions || 0, 0).trendUp,
    },
  ];
  return stats;
};

const calculateTrend = (current, previous) => {
  if (previous === 0 && current > 0) {
    return { trend: "+100%", trendUp: true };
  }
  if (previous === 0 && current === 0) {
    return { trend: "0%", trendUp: false };
  }
  const change = current - previous;
  const percentChange = ((change / previous) * 100).toFixed(0);
  const isUp = change >= 0;
  return {
    trend: `${isUp ? "+" : ""}${percentChange}%`,
    trendUp: isUp,
  };
};

const formatRecentActivities = (agentData = []) => {
  if (!Array.isArray(agentData)) return [];

  return agentData.map((activity, i) => ({
    id: activity.id || i,
    type: activity.type,
    client: activity.client,
    action: activity.action,
    time: timeAgoIntl(activity.time),
    icon:
      activity.type === "conversion"
        ? "🎯"
        : activity.type === "lead"
        ? "👤"
        : activity.type === "visit"
        ? "📍"
        : activity.type === "lease"
        ? "📦"
        : activity.type === "followup"
        ? "🔔"
        : "ℹ️",
  }));
};

function timeAgoIntl(dateString) {
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  const diff = Date.now() - new Date(dateString).getTime();

  const units = [
    ["year", 1000 * 60 * 60 * 24 * 365],
    ["month", 1000 * 60 * 60 * 24 * 30],
    ["week", 1000 * 60 * 60 * 24 * 7],
    ["day", 1000 * 60 * 60 * 24],
    ["hour", 1000 * 60 * 60],
    ["minute", 1000 * 60],
    ["second", 1000],
  ];

  for (const [unit, ms] of units) {
    const value = Math.floor(diff / ms);
    if (value >= 1) return rtf.format(-value, unit);
  }

  return "just now";
}
